import * as React from "react";
import styled from "styled-components";

interface IProps
  extends React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  id?: string;
  href: string;
}

const OuterLink: React.FC<IProps> = (props) => {
  const { ref, id, href, ...AnchorProps } = props;

  return <A {...AnchorProps} id={id} href={href} />;
};

export default OuterLink;

const A = styled.a`
  color: inherit;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/outer_link.tsx